import { HealthCondition } from './health-condition';
import { HealthSeverity } from './health-severity';

function compareSeverity<T extends HealthCondition<string, object>>(a: T, b: T): number {
	if (a.severity.score > b.severity.score) {
		return -1;
	} else if (a.severity.score < b.severity.score) {
		return 1;
	}

	return 0;
}

function compareDetectedTimestamp<T extends HealthCondition<string, object>>(a: T, b: T): number {
	if (a.detectedAt > b.detectedAt) {
		return 1;
	} else if (b.detectedAt > a.detectedAt) {
		return -1;
	}

	return 0;
}

export class OrderedHealthConditionCollection<T extends HealthCondition<string, object>> {
	private readonly items: T[];

	readonly [n: number]: T;

	constructor(init?: T[]) {
		this.items = init ?? [];
		this.items.sort(this.compare);
	}

	public [Symbol.iterator](): Iterator<T> {
		return this.items[Symbol.iterator]();
	}

	public get length(): number {
		return this.items.length;
	}

	public get worstSeverity(): HealthSeverity | undefined {
		return this.items[0]?.severity;
	}

	private compare(a: T, b: T): number {
		const bySeverity = compareSeverity(a, b);
		return bySeverity !== 0 ? bySeverity : compareDetectedTimestamp(a, b);
	}
}
